
import { Box, Alert, AlertTitle } from '@mui/material';



export const AlertScreen = ({ title }) => {


    return (

        <Box sx={{ display:'flex', justifyContent:'center', alignItems:'center', width:'100%', height:'100%' }}>
            <Alert severity="info" sx={{ width:'100%', display:'flex', alignItems:'center', justifyContent:'center'}}>
                <AlertTitle sx={{ fontSize: "18px", mt: 1, textAlign: 'center' }}>
                    {title}
                </AlertTitle>
            </Alert>
        </Box>
    )
}
